import type { CartItem } from '@/features/totems/domain/model/cart-item';
import type { MenuSnapshotProduct } from '@/features/totems/domain/model/menu-snapshot';
import { productHasSubselections } from '@/features/totems/domain/service/category-products';

export function shouldOpenProductSheet(product: MenuSnapshotProduct, _cartItems: CartItem[]): boolean {
  return productHasSubselections(product);
}
